// DS: I32B
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import React from 'react';
import IconWrap from '../IconWrap';
const CloseBig = (props)=>{
    const uniqueId = useUniqueId();
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "0",
        height: "0",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: `i32-b-${uniqueId}`,
        d: "M13.765 12L22 20.235 20.235 22 12 13.765 3.765 22 2 20.235 10.235 12 2 3.765 3.765 2 12 10.235 20.235 2 22 3.765 13.765 12z"
    })), /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("use", {
        fill: "currentColor",
        xlinkHref: `#i32-b-${uniqueId}`
    }))));
};
CloseBig.displayName = 'CloseBig';
export default CloseBig;
